import type { ReactNode } from 'react';
import { Component } from 'react';
import type { DefaultComponentProps } from '../types';
import { WidgetError } from './WidgetError';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<
  DefaultComponentProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);

    this.state = {
      hasError: false
    };
  }

  public static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(error: Error): void {
    console.error('Catch Error:', error);
  }

  public render(): ReactNode {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        <WidgetError>
          Oops, something went wrong. See the console for details and contact
          support.
        </WidgetError>
      );
    }

    return children;
  }
}
